import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { StoreModule } from '@ngrx/store';
import * as fromFaqStore from './faq-store.reducer';
import { EffectsModule } from '@ngrx/effects';
import { FaqStoreEffects } from './faq-store.effects';



@NgModule({
  declarations: [],
  imports: [
    CommonModule,
    StoreModule.forFeature(fromFaqStore.faqStoreFeatureKey, fromFaqStore.reducer),
    EffectsModule.forFeature([FaqStoreEffects])
  ]
})
export class FaqStoreModule { }
